import s from "./basket.module.css";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";
import BasketItem from "./BasketItem";
import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import {NavLink} from "react-router-dom";
import {setHistory} from "../../store/OrdersHistorySlice";
import {clearOrders} from "../../store/OrderSlice";
import {deleteOrderServer} from "../../firebase";
import useDocumentTitle from "../../assets/Tools/DocumentTitle/DocumentTitle";

const Basket = () => {
    const basketData = useSelector(state => state.setOrder.productsToOrder);
    const sum = useSelector(state => state.setOrder.sum);
    const orders = useSelector(state => state.setOrder.productsToOrder);
    const dispatch = useDispatch();
    const userId = useSelector(state => state.authUser.userId);


    useDocumentTitle('Корзина');

    return (
        <div className={s.basket}>
            <div className={`${s.basketContent} content`}>
                <Breadcrumbs/>
                <h3>Корзина покупок</h3>
                <div className={s.basketMain}>
                    <div className={s.basketTitle}>
                        <ul>
                            <li>Изображение</li>
                            <li>Наименование товара</li>
                            <li>Количество</li>
                            <li>Цена</li>
                            <li>Итого</li>
                        </ul>
                    </div>
                    <div className={s.basketItem}>
                        {basketData.map((item, index) => {
                            return (
                                <BasketItem key={item.id * index} item={item} indexOfItem={index}/>
                            )
                        })}
                    </div>
                </div>
                <div className={s.basketSum}>
                    <div><p>Сумма: <span>{sum} грн</span></p></div>
                </div>
                <div className={s.basketButtons}>
                    <NavLink to="/categories"><BuyButton>Продолжить покупки</BuyButton></NavLink>
                    <NavLink to="order-checkout" onClick={() => {
                        const obj = Object.assign({}, orders)
                        dispatch(setHistory(obj));
                        dispatch(clearOrders());
                        deleteOrderServer(userId);
                    }}><BuyButton>Оформить</BuyButton></NavLink>
                </div>
            </div>
        </div>
    )
}

export default Basket;